export default "__VITE_ASSET__DA5UB9JP__"